import { Link } from "react-router-dom";
import type { ArticleMeta } from "@/mocks/articles";

export default function ArticleCard({ article }: { article: ArticleMeta }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.coverAlt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500/95 px-2.5 py-1 text-xs font-semibold text-background-50">
          {article.categoryName}
        </span>
        {article.hot && (
          <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-fire-fill" /> 热
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-pen-nib-line text-primary-500" />
            {article.author}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line" />
            {article.date} · {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}